/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'

class ReportLocationStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deliveryLocationTypes: [],
      deleteModal: false,
      editModal: false,
      deliveryLocationName: '',
      printInfo: []
    }
  }

  callReportDeliveryLocation = () => {
    http.get(`${ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT}`, {}).then((response) => {
      if (response.data.error == null) {
        // alert(JSON.stringify(response.data))
        this.setState({
          deliveryLocationTypes: response.data.object.result,
          total: response.data.object.countAll
        })
      } else {
        this.setState({
          deliveryLocationTypes: []
        })
      }
    })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    this.callReportDeliveryLocation()
  }

  onResultFetched(data) {
    this.setState({
      deliveryLocationTypes: data
    })
  }

  changeDropDown(data) {
    this.setState({
      deliveryLocationTypes: data,
      lengthProducts: this.state.total
    })
  }

  deleteDeliveryLocation = (id, name) => {
    sessionStorage.setItem('deliveryLocationId', id)
    this.setState({
      deleteModal: !this.state.deleteModal,
      deliveryLocationName: name
    })
  }

  toggleDelete = () => {
    sessionStorage.removeItem('deliveryLocationId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      deliveryLocationName: ''
    })
  }
  deleteCancel = () => {
    sessionStorage.removeItem('deliveryLocationId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      deliveryLocationName: ''
    })
  }
  deleteOk = () => {
    let deliveryLocationId = sessionStorage.getItem('deliveryLocationId')
    let data = {
      deliveryLocationId: Number(deliveryLocationId)
    }
    http.post(`${ORDER_STATUS.ORDERS_STAUTS_ORDERDELIVERYLOCATION_DELETE}`, data, {}).then((response) => {
      if (response.data.error == null) {
        message.success('محل تحویل با موفقیت حذف شد')
        this.deleteCancel()
        this.callReportDeliveryLocation()
        sessionStorage.setItem('pageNumber', '1')
        sessionStorage.setItem('dropDownVal', '10')
      } else {
        message.error(response.data.description)
      }
    })
  }

  editDeliveryLocation = (num, id, name, enable, color) => {
    this.setState({
      editModal: !this.state.editModal,
      deliveryLocationId: id,
      deliveryLocationName: name,
      deliveryLocationEnable: enable,
      deliveryLocationColor: color
    })
  }

  editCancel = () => {
    this.setState({
      editModal: !this.state.editModal,
      deliveryLocationId: '',
      deliveryLocationName: '',
      deliveryLocationEnable: '',
      deliveryLocationColor: ''
    })
  }
  toggleEdit = () => {
    this.editCancel()
  }

  editOk = () => {
    var deliveryLocationName = document.getElementById('name').value
    var enabled = document.getElementById('enabled').value
    let data = {
      deliveryLocationId: this.state.deliveryLocationId,
      deliveryLocationName,
      enabled
    }

    http.post(`${ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_UPDATE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('ویرایش با موفقیت انجام شد')
        this.editCancel()
        this.callReportDeliveryLocation()
        sessionStorage.setItem('pageNumber', '1')
        sessionStorage.setItem('dropDownVal', '10')
      } else {
        message.error(response.data.errorCode)
      }
    })
  }

  exportExcel = () => {
    http
      .get(
        `${
          ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(
        `${ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT}?export=true&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'عنوان', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="وضعیت سفارشات - محل های تحویل"
              headerColSpan={3}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((deliveryLocation, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{deliveryLocation.deliveryLocationName}</td>
                  <td>{deliveryLocation.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="وضعیت سفارشات - وضعیت ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'deliveryLocationName'}
                field={'deliveryLocationName'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>وضعیت سفارشات</li>
            <li>محل تحویل</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/base/deliveryLocation/addDeliveryLocation"
                  url={ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عنوان</td>
                    <td>وضعیت فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>

                  {this.state.deliveryLocationTypes.map((deliveryLocation, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{deliveryLocation.deliveryLocationName}</td>

                      <td>
                        {deliveryLocation.enabled ? (
                          <img src={require('../../image/confirm.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt="" />
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.editDeliveryLocation(
                              index,
                              deliveryLocation.deliveryLocationId,
                              deliveryLocation.deliveryLocationName,
                              deliveryLocation.enabled,
                              deliveryLocation.color
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.deleteDeliveryLocation(
                              deliveryLocation.deliveryLocationId,
                              deliveryLocation.deliveryLocationName
                            )
                          }
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.deleteModal} toggle={this.toggleDelete} size="sm">
          <ModalHeader toggle={this.toggleDelete}>حذف محل تحویل</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف محل تحویل {this.state.deliveryLocationName} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف محل تحویل
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.toggleEdit} size="sm">
          <ModalHeader toggle={this.toggleEdit}>ویرایش محل تحویل</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label> نام محل تحویل: </label>
                <input className="form-control" type="text" defaultValue={this.state.deliveryLocationName} id="name" />
              </div>

              <div className="formComponent">
                <label> وضعیت محل تحویل: </label>

                <select className="form-control" name="enabled" id="enabled">
                  <option selected={this.state.deliveryLocationEnable == 1 ? true : false} value={1}>
                    فعال
                  </option>
                  <option selected={this.state.deliveryLocationEnable == 0 ? true : false} value={0}>
                    غیر فعال
                  </option>
                </select>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش محل تحویل
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportLocationStatus
